import React from 'react';
import PropTypes from 'prop-types';
import { AnimatedAxis as AnAxis } from '@visx/react-spring';
import { useTheme } from '@material-ui/core/styles';

// short month
const formatMonth = (date) =>
  `${new Date(date).toLocaleString('en-us', { month: 'short' })}`;

const MonthAxis = ({ scale, dimensions }) => {
  const { maxHeight, margin } = dimensions;
  const theme = useTheme();
  const axisColor = theme.palette.primary.main;

  return (
    <AnAxis
      orientation="bottom"
      top={maxHeight + margin.top}
      scale={scale}
      tickFormat={formatMonth}
      stroke={axisColor}
      tickStroke={axisColor}
      tickLabelProps={() => ({
        fill: axisColor,
        fontSize: 11,
        textAnchor: 'middle',
        dy: '4',
      })}
    />
  );
};

MonthAxis.propTypes = {
  scale: PropTypes.func.isRequired,
  dimensions: PropTypes.object.isRequired,
};

export default MonthAxis;
